module.exports = __webpack_public_path__ + "img/header-img-baelle.ef81af83.jpg";